import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagePackageLeadsRoutingModule } from './manage-package-leads-routing.module';
import { ManagePackageLeadsComponent } from './manage-package-leads/manage-package-leads.component';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import {FileUploadModule} from 'primeng/fileupload';
import { ToastModule} from 'primeng/toast';
import {TableModule } from 'primeng/table';
import {ToggleButtonModule } from 'primeng/togglebutton';
import {DropdownModule } from 'primeng/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';;
import {PaginatorModule} from 'primeng/paginator';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {MultiSelectModule} from 'primeng/multiselect';
import {CalendarModule} from 'primeng/calendar';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {SliderModule} from 'primeng/slider';
import {InputSwitchModule} from 'primeng/inputswitch';


@NgModule({
  declarations: [ManagePackageLeadsComponent],
  imports: [
    CommonModule,
    ManagePackageLeadsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    ModalModule,
    FileUploadModule,
    ToggleButtonModule,
    TableModule,
    ToastModule,
    PaginatorModule,
    AutoCompleteModule,
    MultiSelectModule,
    CalendarModule,
    TypeaheadModule,
    TooltipModule,
    BsDatepickerModule,
    SliderModule,
    InputSwitchModule,

  ]
})
export class ManagePackageLeadsModule { }
